const initialFileMetaDataValueState = {
  data : [],
  columns: [],
  dataWithCategory: []

}

export const FileMetaDataValueReducer = (state = initialFileMetaDataValueState, action = {}) => {    
    
    switch (action.type) {    
 
        case 'FILEMETADATAVALUE':       
            return {
              ...state,
              data: action.fetchedFileMetaData.data.data,
              columns: action.fetchedFileMetaData.data.columns

            }
        
        case 'METAVALUESWITHCATEGORY':        
        return {
              ...state,
              dataWithCategory: action.fetchedFileMetaData.data
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/FileMetaDataValueReducer.js